export const SERVICE_NOTIFICATIONS_METHODS = ['Email', 'Phone', 'Mobile']
export const BILLING_NOTIFICATIONS_METHODS = ['Email']
